import React, { useEffect, useState } from 'react';
import { Container, Table } from 'react-bootstrap';
import classes from './style.module.css'
import League from './League'
import { connect } from "react-redux"
import { JOCKEY_TABLE_COLUMNS_STATIC, JOCKEY_TABLE_COLUMNS_HORSE, JOCKEY_TABLE_COLUMNS_ALL } from '../../constants/Constants'
import { SET_SOCCER_LEAGUES_STATE, SET_SELECTION_STATE } from "../../redux/actions"
import { logInfo } from "../../util/log/logger"
import { getJockeyByDate, getRunnerOddsByMarketId } from "../../service/backend-api-service"
import sortIconImage from "../../assets/images/sort_both.png"
import Spinner from "../UI/Spinner"
import { Button, ButtonGroup } from 'react-bootstrap'

const LeagueTable = (props) => {
    const [sortOrder, setSortOrder] = useState(true) // true - ascending and false - descending
    const [sortColumn, setSortColumn] = useState(null)
    const [loadingState, setLoadingState] = useState(0)
    const [allOdds, setAllOdds] = useState(new Map())


    const staticColumns = []
    for (let value in JOCKEY_TABLE_COLUMNS_STATIC) staticColumns.push(JOCKEY_TABLE_COLUMNS_STATIC[value])

    const horseColumns = []
    for (let value in JOCKEY_TABLE_COLUMNS_HORSE) staticColumns.push(JOCKEY_TABLE_COLUMNS_HORSE[value])

    const finalColumns = [...staticColumns, ...horseColumns];

    const sortIconClickedHandler = columnId => {
        setSortColumn(columnId)
        if (sortColumn === columnId) setSortOrder(!sortOrder)
    }

    const filterHorseCoulmn = (column) => {
        return ((props.tab.id === 'COURSE_DISTANCE' || props.tab.id === 'LONGEST_TRAVELLER' ||
            props.tab.id === 'FIRST_TIME_VISORS' || props.tab.id === 'FIRST_TIME_BLINKERS' ||
            props.tab.id === 'CHEEK_PIECE' || props.tab.id === 'TONGUE_STRAP')
            && column === 'HORSE')
    }

    const filterNameCoulmn = (column) => {
        return ((props.tab.id === 'COURSE_DISTANCE' || props.tab.id === 'LONGEST_TRAVELLER' ||
            props.tab.id === 'FIRST_TIME_VISORS' || props.tab.id === 'FIRST_TIME_BLINKERS' ||
            props.tab.id === 'CHEEK_PIECE' || props.tab.id === 'TONGUE_STRAP')
            && column === 'NAME')
    }

    const filterDaysSinceLastRunCoulmn = (column) => {
        return ((props.tab.id === 'HOT_JOCKEY' || props.tab.id === 'HOT_TRAINER')
            && (column == 'DAYS_SINCE_LAST_RUN'))
    }

    const tableHeaders = finalColumns.filter(x => !filterHorseCoulmn(x.id)).filter(x => !filterDaysSinceLastRunCoulmn(x.id)).map(column => {
        let sortIcon = null
        const description = filterNameCoulmn(column.id) ? "Horse" : column.description
        if (!(column.id == JOCKEY_TABLE_COLUMNS_STATIC.ROW_NUM.id ||
            column.id == JOCKEY_TABLE_COLUMNS_ALL.ODD_DETAILS.id ||
            column.id == JOCKEY_TABLE_COLUMNS_ALL.WIN_DETAILS.id))
            sortIcon = <img src={sortIconImage} alt="Sort" onClick={() => sortIconClickedHandler(column.id)} />
        if (column.id === JOCKEY_TABLE_COLUMNS_ALL.ODD_DETAILS.id) {
            return (
                <th key={column.id}><ButtonGroup size="sm">
                    <Button style={{ backgroundColor: "#74BBEF" }} variant="outline-dark"><b>Back</b></Button>
                    <Button style={{ backgroundColor: "#F8AAB8" }} variant="outline-dark"><b>Lay</b></Button>
                </ButtonGroup>
                </th>
            );
        } else {
            return (
                <th key={column.id}>{description} {sortIcon}</th>
            );
        }
    })

    function isNumeric(num) {
        return !isNaN(num)
    }

    const compare = (a, b) => {
        if (a === b) return 0
        if (a === null || a === "-") return 1
        if (b === null || b === "-") return -1
        if (isNumeric(a) && isNumeric(b)) {
            let numbericA = parseInt(a)
            let numbericB = parseInt(b)
            if (sortOrder) return numbericA < numbericB ? -1 : 1;
            else return numbericA < numbericB ? 1 : -1;
        }
        if (sortOrder) return a < b ? -1 : 1;
        else return a < b ? 1 : -1;
    }

    function findProp(obj, prop, defval) {
        if (typeof defval == 'undefined') defval = null;
        prop = prop.split('.');
        for (var i = 0; i < prop.length; i++) {
            if (typeof obj[prop[i]] == 'undefined')
                return defval;
            obj = obj[prop[i]];
        }
        return obj;
    }

    function convertToNumber(percent) {
        return parseFloat(percent.replaceAll("%", ""))
    }

    const pushUnmatchedLast = (a,b) =>{
        //console.log("************1" + JSON.stringify(a))
        return (a.runner && a.runner === "-") ? 1 : -1
    }
    const sortHotJockey = hotJockeys => {
        const jsonFieldId = finalColumns.find(element => element.id === sortColumn).jsonFieldId
        if (hotJockeys.length > 0) {
            if (jsonFieldId && jsonFieldId.indexOf(".") != -1) {
                hotJockeys.sort((a, b) => compare(findProp(a, jsonFieldId), findProp(b, jsonFieldId)))
                props.setSoccerLeaguesState(hotJockeys)
            } else if (sortColumn && (sortColumn === 'WIN_PERCENT' || sortColumn === 'PLACE_PERCENT')) {
                hotJockeys.sort((a, b) => compare(convertToNumber(a[jsonFieldId]), convertToNumber(b[jsonFieldId])))
                props.setSoccerLeaguesState(hotJockeys)
            } else {
                hotJockeys.sort((a, b) => compare(a[jsonFieldId], b[jsonFieldId]))
                props.setSoccerLeaguesState(hotJockeys)
            }
        }
    }
    const getTicklerRace = async (date, tab) => {
        let apiData = await getJockeyByDate(date, tab)
        logInfo(`LeagueTable | useEffect | leagues loaded. count: ${apiData.length}`)
        return apiData.map(apiData => {
            for (let key in apiData) {
                if (apiData[key] === null) {
                    apiData[key] = "-"
                }
            }
            return apiData
        })
    }

    const oddChangeCallback = (marketId, selectionId, odds) => {
        allOdds.delete(marketId + ":" + selectionId)
        allOdds.set(marketId + ":" + selectionId, odds);
        //    console.log(JSON.stringify(allOdds))
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoadingState(0)
            let date = props.selectionState.selectionDate
            let apiData = await getTicklerRace(date, props.tab)
            props.setSoccerLeaguesState(apiData)
            if (apiData.length > 0) {
                if (props.tab.id === 'HOT_JOCKEY' || props.tab.id === 'HOT_TRAINER') {
                    setSortColumn(JOCKEY_TABLE_COLUMNS_STATIC.WINS.id)
                } else {
                    setSortColumn(JOCKEY_TABLE_COLUMNS_STATIC.ROW_NUM.id)
                }
                setLoadingState(2)
            } else {
                setLoadingState(1)
            }
        }
        fetchData();
    }, [props.selectionState])

    useEffect(() => {
        if (sortColumn != null) {
            const soccerLeaguesState = [...props.soccerLeaguesState]
            sortHotJockey(soccerLeaguesState)
        }
    }, [sortColumn, sortOrder])

    const applyFilter = (match) => {
        //console.log("in apply filter:" + JSON.stringify(props.matchFilter));
        //console.log("in apply filter:" + JSON.stringify(match));
        //Filter format [{"name":"runner.metadata.AGE","value":[4,6]},{"name":"runner.metadata.DAYS_SINCE_LAST_RUN","value":[17,33]}]
        //Return true only of match satisfy this criteria.
        //or invalid value
        let filters = props.matchFilter;
        if (filters.length > 0) {
            for (let i = 0; i < filters.length; i++) {
                let filter = filters[i]
                if (filter.name === "runner.metadata.AGE" && match && match.runner && match.runner.metadata) {
                    let age = parseInt(match.runner.metadata["AGE"])
                    if (age < filter.value[0] || age > filter.value[1]) {
                        return false;
                    }
                }
                if (filter.name === "runner.metadata.DAYS_SINCE_LAST_RUN" && match && match.runner && match.runner.metadata) {
                    let daysSinceLastRun = parseInt(match.runner.metadata["DAYS_SINCE_LAST_RUN"])
                    if (daysSinceLastRun < filter.value[0] || daysSinceLastRun > filter.value[1]) {
                        return false;
                    }
                }

                if (filter.name === "runner.metadata.backOdds" && match.runner && match.runner.selectionId && match.eventDetails && match.eventDetails.bfMarketId) {
                    let odds = allOdds.get(match.eventDetails.bfMarketId + ":" + match.runner.selectionId)

                    if (odds && (odds.bestBackOdd < filter.value[0] || odds.bestBackOdd > filter.value[1])) {
                        return false;
                    }
                }
            };

        }
        return true;
    }


    const itemList = props.soccerLeaguesState.sort(pushUnmatchedLast).filter(applyFilter).map((item, index) => {
        const itemKey = item.id
        return (
            <League oddChangeCallback={oddChangeCallback} key={itemKey} date={props.selectionState.selectionDate} ticklerTab={props.tab} finalColumns={finalColumns} item={item} index={index} />
        )
    });

    let contentBody = null

    if (loadingState === 0) {
        contentBody = <Spinner />
    } else if (loadingState === 1) {
        contentBody = <div style={{ textAlign: "center" }}>{props.tab.emptyMessage}</div>
    } else {
        contentBody = <Table id={props.tab.id} striped bordered hover size="sm">
            <thead>
                <tr>
                    {tableHeaders}
                </tr>
            </thead>
            <tbody>
                {itemList}
            </tbody>
        </Table>
    }


    return (
        <Container fluid className={classes.LeagueTable}>
            {contentBody}
        </Container>
    )
}

const mapStateToProps = state => {
    return {
        soccerLeaguesState: state.soccerLeaguesState,
        selectionState: state.selectionState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeagueTable);